import config from "config"
import { wordTitleCase } from "helpers/data-formatters"
import { convertToTitleCase } from "helpers/util"
import React from "react"

const TitleText = cell => {
  return wordTitleCase(cell.value)
}
const PermissionsValue = cell => {
  return (
    <>
      {cell.value.map((tag, index) => {
        const Text = convertToTitleCase(tag)
        return (
          <div
            className="badge badge-soft-primary font-size-11 m-1"
            key={"_skill_" + cell.value + index}
          >
            {Text}
          </div>
        )
      })}
    </>
  )
}

export { TitleText, PermissionsValue }
